import { Button, Drawer, Space } from "antd";
import React from "react";
import {
  createVendorCatalogue,
  getVendorCatalogue,
} from "../../../api/vendor.api";
import styles from "./vendorCatalogue.module.scss";
import { useDropzone } from "react-dropzone";
import { CloseOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";

export const VendorCatalogue = ({ vendor, open, onClose }) => {
  const [catalogues, setCatalogues] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [files, setFiles] = React.useState([]);
  const [showUploader, setShowUploader] = React.useState(true);

  const onDrop = React.useCallback((acceptedFiles) => {
    setFiles(acceptedFiles);
  }, []);

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  React.useEffect(() => {
    if (!vendor) return;

    getVendorCatalogue(vendor.id)
      .then((res) => {
        if (!Array.isArray(res)) {
          res = [res];
        }

        setCatalogues(res);
      })
      .finally(() => setLoading(false));
  }, [vendor]);

  const onSubmit = () => {
    if (files.length === 0) {
      toast.error("Please select a file");
      return;
    }

    const formData = new FormData();
    formData.append("file", files[0]);
    formData.append("vendor", vendor.id);

    createVendorCatalogue(formData).then((res) => {
      setFiles([]);
      setCatalogues(res);
      toast.success("Catalogue uploaded successfully");
      onClose();
    });
  };

  const uploadView = React.useMemo(
    () => (
      <section>
        <div {...getRootProps()} className={styles.inputArea}>
          <input {...getInputProps()} />
          Click or drag file to this area to upload
        </div>
        {files[0] && (
          <div className={styles.file}>
            <div className={styles.fileName}>{files[0].name}</div>
            <span className={styles.close} onClick={() => setFiles([])}>
              <CloseOutlined />
            </span>
          </div>
        )}
      </section>
    ),
    [files, getRootProps, getInputProps]
  );

  const catalogueView = React.useMemo(
    () =>
      catalogues?.length > 0 && (
        <>
          {showUploader && uploadView}
          <h2>Catalogues</h2>
          {catalogues.map((catalogue) => (
            <div className={styles.catalogue}>
              <a
                href={catalogue.file}
                target="_blank"
                rel="noreferrer"
                className={styles.catalogueName}
              >
                {catalogue.file.split("/").pop()}
              </a>
            </div>
          ))}
        </>
      ),
    [catalogues, showUploader, uploadView]
  );

  const view = React.useMemo(() => {
    if (!catalogues || (Array.isArray(catalogues) && catalogues.length === 0))
      return uploadView;

    return catalogueView;
  }, [catalogues, uploadView, catalogueView]);

  return (
    <Drawer
      title="Vendor Catalogue"
      placement="right"
      closable={true}
      visible={open}
      onClose={onClose}
      width={500}
      footer={
        <Space justify="end">
          <Button onClick={onClose}>Close</Button>
          {catalogues?.length > 0 && !showUploader && (
            <Button onClick={() => setShowUploader(true)}>Edit</Button>
          )}
          <Button type="primary" onClick={onSubmit}>
            Submit
          </Button>
        </Space>
      }
    >
      {view}
    </Drawer>
  );
};
